import RelatoriosService from "@/services/RelatoriosService.js";

export default {
  data() {
    return {
      downloadProgressData: {},
    };
  },
  methods: {
    downloadSpreadSheet(id, tipo = 'xlsx') {
      this.$set(this.downloadProgressData, id, { id });
      this.$toast.info("Preparando seu arquivo para download.", "", {
        position: "topRight",
        timeout: 2500,
      });

      RelatoriosService.getRelatorioSpreadSheet(id, tipo, {
        timeout: 60 * 60 * 1000,
        onDownloadProgress: (progressEvent) => {
          let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          let isComputable = progressEvent.lengthComputable;
          this.$set(this.downloadProgressData, id, {
            progress,
            isComputable,
            id,
          });
        },
      })
      .then(async (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", await this.getNomeSpreadSheet(id, tipo));
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error);
        this.$toast.error("Erro no download do arquivo.", "", {
          position: "topRight",
        });
      })
      .finally(() => {
        this.$delete(this.downloadProgressData, id);
      });
    },
    getNomeSpreadSheet(id, tipo) {
      return RelatoriosService.getRelatorioConsultaNomeArquivo(id, tipo)
        .then(response => response.data.nome)
        .catch(error => {
          console.error(error)
          this.$toast.error("Erro ao pegar nome do arquivo.", "", {
            position: "topRight",
          });
        });
    },
  },
}
